import { Flex, Text } from '@radix-ui/themes'

export const FieldWrapper = ({
  label,
  htmlFor,
  description,
  children
}: {
  label: string
  htmlFor?: string
  description?: string
  children: React.ReactNode
}) => {
  return (
    <Flex direction={'column'} gap="1">
      <Text as="label" htmlFor={htmlFor} size="2" weight={'medium'}>
        {label}
      </Text>
      {description && (
        <Text as="p" size="1" color="gray">
          {description}
        </Text>
      )}
      {children}
    </Flex>
  )
}
